export const environment = {
  host: 'https://api.iwentsourcing.com',
  tenant: 'iwentsourcing',
};
